import { useMemo } from "react";
import { HomePhoneFeature, HomePhoneProduct } from "../../../../../types/homePhone";
import { DEFAULT_FEATURES } from "../constants";

interface UseProductDetailResult {
  features: HomePhoneFeature[];
}

const useProductDetail = (product: HomePhoneProduct): UseProductDetailResult => {
  const features = useMemo(
    () =>
      product.features?.length
        ? product.features
        : [...DEFAULT_FEATURES],
    [product.features],
  );

  return { features };
};

export default useProductDetail;
